export function readCookie(name: string): string | null {
  const prefix = `${name}=`;
  for (const part of document.cookie.split(";")) {
    const c = part.trim();
    if (c.startsWith(prefix)) return decodeURIComponent(c.slice(prefix.length));
  }
  return null;
}

export const CSRF_COOKIE = "cp_csrf";
export const CSRF_HEADER = "X-CSRF-Token";

export function csrfToken(): string | null {
  return readCookie(CSRF_COOKIE);
}
